import { motion } from 'framer-motion';
import { siteConfig } from '../data/siteData';

export default function Terms() {
  return (
    <div data-testid="terms-page">
      {/* Hero Section */}
      <section className="py-20 md:py-32 bg-brand-accent">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl md:text-6xl font-bold text-brand-primary mb-6">
              Terms & Conditions
            </h1>
            <p className="text-slate-600 text-lg">Last updated: January 2024</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              1. Acceptance of Terms
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              By accessing and using this website, you accept and agree to be bound by the terms and
              provisions of this agreement. If you do not agree to these terms, please do not use
              this website.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              2. Use of Website
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              This website is for informational purposes and to facilitate communication regarding
              speaking, consulting, and advisory services. The content provided is for general
              information only and should not be relied upon as professional advice.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              3. Intellectual Property
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              All content on this website, including text, graphics, logos, images, audio clips,
              video clips, and software, is the property of {siteConfig.name} and is protected by
              copyright laws. You may not reproduce, distribute, or create derivative works from any
              content without express written permission.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              4. Services
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Services described on this website (speaking, consulting, advisory) are subject to
              separate agreements. Specific terms, conditions, and pricing will be provided upon
              request and are subject to negotiation and formal contract.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              5. User Submissions
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Any information you submit through contact forms or other means becomes the property
              of {siteConfig.name}. By submitting information, you warrant that you have the right
              to submit such information and that the information is accurate.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              6. Limitation of Liability
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              {siteConfig.name} shall not be liable for any direct, indirect, incidental, special,
              or consequential damages resulting from the use or inability to use this website or
              services, even if advised of the possibility of such damages.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              7. External Links
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              This website may contain links to external sites. {siteConfig.name} is not responsible
              for the content, privacy policies, or practices of external websites.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              8. Changes to Terms
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              {siteConfig.name} reserves the right to modify these terms at any time. Changes will
              be effective immediately upon posting to the website. Your continued use of the
              website constitutes acceptance of modified terms.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              9. Contact Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              For questions about these Terms & Conditions, please contact us through the contact
              form on this website.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
